import React from 'react';
import {
  AreaChart,
  Area,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  ResponsiveContainer
} from 'recharts';
import { useAppStore } from '../../store';
import { subDays, format } from 'date-fns';

export const TaskCompletionChart = () => {
  const tasks = useAppStore((state) => state.tasks);

  const generateChartData = () => {
    const days = 7;
    const data = [];
    const today = new Date();

    for (let i = days - 1; i >= 0; i--) {
      const date = subDays(today, i);
      const dateStr = format(date, 'yyyy-MM-dd');
      
      const dayTasks = tasks.filter(task => 
        format(new Date(task.createdAt), 'yyyy-MM-dd') === dateStr
      );
      
      const completed = dayTasks.filter(task => 
        task.status === 'Completed'
      ).length;

      data.push({
        date: dateStr,
        completed,
        total: dayTasks.length
      });
    }

    return data;
  };

  const data = generateChartData();

  return (
    <ResponsiveContainer width="100%" height={300}>
      <AreaChart data={data} margin={{ top: 10, right: 30, left: 0, bottom: 0 }}>
        <defs>
          <linearGradient id="colorCompleted" x1="0" y1="0" x2="0" y2="1">
            <stop offset="5%" stopColor="#4b39ef" stopOpacity={0.8}/>
            <stop offset="95%" stopColor="#4b39ef" stopOpacity={0}/>
          </linearGradient>
          <linearGradient id="colorTotal" x1="0" y1="0" x2="0" y2="1">
            <stop offset="5%" stopColor="#39d2c0" stopOpacity={0.8}/>
            <stop offset="95%" stopColor="#39d2c0" stopOpacity={0}/>
          </linearGradient>
        </defs>
        <CartesianGrid strokeDasharray="3 3" />
        <XAxis
          dataKey="date"
          tickFormatter={(str) => format(new Date(str), 'MMM d')}
        />
        <YAxis />
        <Tooltip
          labelFormatter={(value) => format(new Date(value), 'MMM d, yyyy')}
          formatter={(value, name) => [value, name === 'total' ? 'Total Tasks' : 'Completed Tasks']}
        />
        <Area
          type="monotone"
          dataKey="total"
          name="Total Tasks"
          stroke="#39d2c0"
          fillOpacity={1}
          fill="url(#colorTotal)"
        />
        <Area
          type="monotone"
          dataKey="completed"
          name="Completed Tasks"
          stroke="#4b39ef"
          fillOpacity={1}
          fill="url(#colorCompleted)"
        />
      </AreaChart>
    </ResponsiveContainer>
  );
};